export default __webpack_public_path__ + "static/media/to-do.eb110456.PNG";